export default __webpack_public_path__ + "static/media/RZ_Car_Lora_Thumb.120909fb.jpg";